/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureSqlDatabaseRestoreTarget {
  /**
  * Region to restore to.
  */
  'region': string;
  /**
  * Name of the resource group to restore to.
  */
  'resourceGroupName': string;
  /**
  * Restored SQL server name.
  */
  'serverName': string;
  /**
  * Username to set for admin of user of the restored database.
  */
  'adminUserName': string;
  /**
  * Tags to apply to the restored instance as key-value pairs, where key and value are both strings. If not provided, defaults to an empty object, with no tags applied.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "serverName",
      "baseName": "serverName",
      "type": "string",
      "format": ""
    },
    {
      "name": "adminUserName",
      "baseName": "adminUserName",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureSqlDatabaseRestoreTarget.attributeTypeMap;
  }

  public constructor() {
  }
}

